import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DataService } from 'src/app/providers/common/data.service';

@Injectable({
  providedIn: 'root'
})
export class DataResolverService  {

  constructor(private dataService: DataService) { }

  resolve(route: ActivatedRouteSnapshot) {
    let id: number | string = route.paramMap.get('id');
    return this.dataService.getData(id);
  }
}
